const STATUS_CODE_META_TAG = 'prerender-status-code';

const getStatusCodeMetaTag = () => document.querySelector(`[name='${STATUS_CODE_META_TAG}']`);

export const setStatusCodeMetaTag = () => {
  if (!getStatusCodeMetaTag()) {
    const meta = document.createElement('meta');
    meta.name = STATUS_CODE_META_TAG;
    meta.content = '404';
    document.getElementsByTagName('head')[0].appendChild(meta);
  }
};

export const removeStatusCodeMetaTag = () => {
  const node = getStatusCodeMetaTag();
  node && node.remove();
};
